export const portfolioPage = 'portfolioPage';
export const portfolioPlusIcon = 'portfolio-plus-icon';

export const portfolioChart = 'portfolio-chart';
export const portfolioNoData = 'tid-no-data';
export const portfolioLegend = 'tid-legend';
